// extracted by mini-css-extract-plugin
export default {"container":"BranchesDialogContent_container__iLL5y"};